<template>
    <div class="app-main">
      <transition name="fade-transform" mode="out-in">
        <keep-alive >
          <router-view  />
        </keep-alive>
      </transition>
    </div>
  </template>
  
  <script>
  
  export default {
    name: 'AppMain',
    computed: {
      key() {
        return this.$route.path
      }
    }
  }
  </script>
  
  <style lang="scss">
  .app-main {
    /* 50= navbar  50  */
    height: calc(100vh - 60px);
    width: 100%;
    position: relative;
  }
  
  .fixed-header + .app-main {
    padding-top: 50px;
  }
  
  .hasTagsView {
    .app-main {
      /* 84 = navbar + tags-view = 50 + 34 */
      min-height: calc(100vh - 84px);
    }
  
    .fixed-header + .app-main {
      padding-top: 84px;
    }
  }

  // fix css style bug in open el-dialog
  .el-popup-parent--hidden {
    .fixed-header {
      padding-right: 17px;
    }
  }
  </style>